"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverCarouselFooter: function() {
        return _index.TeachingPopoverCarouselFooter;
    },
    renderTeachingPopoverCarouselFooter_unstable: function() {
        return _index.renderTeachingPopoverCarouselFooter_unstable;
    },
    teachingPopoverCarouselFooterClassNames: function() {
        return _index.teachingPopoverCarouselFooterClassNames;
    },
    useTeachingPopoverCarouselFooterStyles_unstable: function() {
        return _index.useTeachingPopoverCarouselFooterStyles_unstable;
    },
    useTeachingPopoverCarouselFooter_unstable: function() {
        return _index.useTeachingPopoverCarouselFooter_unstable;
    }
});
const _index = require("./components/TeachingPopoverCarouselFooter/index");
